// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3U5Xu","disabled":"Checkbox_disabled__ydwan","mark":"Checkbox_mark__tXwPa","label":"Checkbox_label__5opqK"};